// Below line shows type from react-dropzone package. Here we convert it to enum
// code: "file-too-large" | "file-too-small"|"too-many-files"|"file-invalid-type";
export enum DropZoneErrorType {
  FileTooLarge = 'file-too-large',
  FileTooSmall = 'file-too-small',
  FileToMany = 'too-many-files',
  FileInvalidType = 'file-invalid-type',
}
